import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { history } from '../../index';
import { loadModules } from 'esri-loader';

import CircularProgress from 'material-ui/CircularProgress';

import theme from '../../muiTheme';
import { incidentOperations } from '../../redux/incident';
import IncidentDetailsContainer from './IncidentDetailsContainer';
import { getMapExtent, setPerimeterGraphic, setMergeGraphic, clearMergeGraphics } from '../esri/mapHub';
import originFields from '../../defaults/PointOfOriginFields.json';

import { setMapViewTarget, clearVisiblePerimeters, clearOriginSelectionGraphics, clearModifiedPerimeter, clearPerimeterGraphics, clearMergedPerimeterGraphics, setOriginSelectionGraphic, refreshOriginLayer, addMergedPerimeterGraphic } from '../esri/mapHub';

class Main extends Component {

  _isMounted = false;

  constructor(props)
  {
      super(props);
      this.state =
      {
          isLoaded: false,
          missingConflictRelationships: (props.history.location !== null && props.history.location.state !== undefined && props.history.location.state.conflictRelationshipsMissing === "true"),
          activeIncidentId: null,
          acresByOwnership: []
      };
  }

  componentWillUnmount()
  {
    this._isMounted = false;
  }

  componentDidMount()
  {
    this._isMounted = true;
    const hasIncidentId = (this.props.match.params.incidentId !== null && this.props.match.params.incidentId !== undefined);

    const routeIncidentId = this.props.match.params.incidentId || null;

    if(hasIncidentId && (routeIncidentId !== null && this.props.map.loaded && this._isMounted))
     {
       getMapExtent().then(
        result =>
          {
             this.props.setPreIncidentExtent(result);
          });
         this.fetchIncident(routeIncidentId);
         this.setState({
           isLoaded: true,
           activeIncidentId: routeIncidentId
          });
     }

  }

  //This entire thing needs to be re-written completely.
  componentWillReceiveProps(nextProps)
  {
    if (!this.props.map.loaded) {
      return;
    }
    const hasIncidentId = (nextProps.match.params.incidentId !== null  && nextProps.match.params.incidentId  !== undefined);

    //If we have a irwin Incident, load it up if it's not the same as before.
    if (hasIncidentId)
    {
      const newIncidentId = nextProps.match.params.incidentId;
      if (newIncidentId !== this.state.activeIncidentId)
      {
        this.setState({
          activeIncidentId: newIncidentId
         });

        getMapExtent().then(
         result =>
           {
              this.props.setPreIncidentExtent(result);
           });

       this.fetchIncident(newIncidentId);

       let wasMissingConflictRelationships = (nextProps.history.location !== null
         && nextProps.history.location.state !== undefined
         && nextProps.history.location.state.conflictRelationshipsMissing === "true");

       this.setState({missingConflictRelationships: wasMissingConflictRelationships});
       this.setState({ isLoaded: true });
      }
    }
  }

  refetchIncidentByForID(forId)
  {
    this.fetchIncident(forId);
  }

  refetchIncident()
  {
    this.fetchIncident(this.props.selectedIncident.incident.attributes[originFields.forId]);
  }

  fetchIncident(uniqueFireId) {

    loadModules(['esri/geometry/Point', 'esri/geometry/SpatialReference', 'esri/geometry/projection', 'esri/geometry/geometryEngine', 'esri/geometry/Polygon'])
    .then(([Point, SpatialReference, projection, GeometryEngine, Polygon]) => {

      if(uniqueFireId)
      {
      
        window.api.loadFullIncidentFromApi(uniqueFireId).then(
          result => {

            if(result)
            { 
              const nad83Geometry = new Point({
                x: result.attributes.x,
                y: result.attributes.y,
                spatialReference: new SpatialReference(4269)
            });

              this.props.setIncident(result);

              if (result.mergedIncidents !== null && result.mergedIncidents.length > 0) 
                {
                projection.load().then(function () {
                  result.mergedIncidents.forEach(mergedIncident => {
                    
                    const mergeGeometry = projection.project(new Point({
                      x: mergedIncident.x,
                      y: mergedIncident.y,
                      spatialReference: new SpatialReference(4269)
                    }), new SpatialReference({ wkid: 102100 }));

                    //setMergeLabelGraphic(mergeGeometry)
                    setMergeGraphic(mergeGeometry, mergedIncident.UniqueFireIdentifier, mergedIncident.MergedOnDateTime).then(() => {

                    });
                  });
                });
              }

              let allPerimeters = [];
              let unionedExtent = null;
              if (result.perimeter && result.perimeter.Feature) 
              {
                allPerimeters.push(new Polygon(result.perimeter.Feature.geometry));
              }

              if (result.mergedPerimeters !== null && result.mergedIncidents.length > 0) 
              {
                result.mergedPerimeters.forEach(mergedPerimeter => {
                  allPerimeters.push(new Polygon(mergedPerimeter.geometry));
                  var matchingMergeIncident = result.mergedIncidents.find(x => x.MergeFireOccurenceRecordID === mergedPerimeter.attributes["MergedFireOccurenceRecordID"]);
                  addMergedPerimeterGraphic(mergedPerimeter, matchingMergeIncident);
                });
              }

              if (allPerimeters.length > 1) 
              {
                unionedExtent = GeometryEngine.union(allPerimeters);
              }

              if (result.perimeter && result.perimeter.Feature)
              {
                  this.props.setPerimeter(result.perimeter.Feature);
                  this.props.setPerimeterFields(result.perimeter.Fields);

                  setPerimeterGraphic(result.perimeter.Feature);

                  setMapViewTarget({
                    target: (unionedExtent != null) ? unionedExtent : result.perimeter.Feature.geometry
                  });
                  refreshOriginLayer();
              }
              else
              {
                this.props.setPerimeter(null);
                this.props.setPerimeterFields(null);

                projection.load().then(function() 
                {
                  const originGeometry = projection.project(nad83Geometry, new SpatialReference({wkid: 102100 }));

                  setMapViewTarget({
                    target: originGeometry.toJSON(),
                    zoom: 14
                  });
                });
              }
              
              projection.load().then(function() 
              {
                const selectionGeometry = projection.project(nad83Geometry, new SpatialReference({wkid: 102100 }));

                setOriginSelectionGraphic(selectionGeometry).then( () => {

                });
              });
            }
            else
            {
              this.closeDetails();
            }
          },
          error => {console.error(error);}
        )
      }
    });
  }

  closeDetails = () => {
    this.props.clearIncident();
    this.props.clearRelationships();
    this.props.clearADSStatus();

    clearVisiblePerimeters();
    clearPerimeterGraphics();
    clearMergedPerimeterGraphics();
    clearModifiedPerimeter();
    clearMergeGraphics();
    clearOriginSelectionGraphics({
      clearExisting: false,
      graphics: [this.props.selectedIncident.incident]
    }).then( () =>
    {
      if (this.props.selectedIncident.preIncidentExtent !== null)
      {
        setMapViewTarget({
          target: this.props.selectedIncident.preIncidentExtent
        });
        this.props.setPreIncidentExtent(null);
      }
    });

    history.push('/incidents');
  }

  openMergeDialog = (incident) => {
    if (this.props.match.params.incidentId !== undefined)
      {
          history.push('/incidents/'+this.props.match.params.incidentId+'/conflict');
      }
  }

  render() {
    let  content = (
      <CircularProgress size={140} thickness={3} color={theme.palette.primary1Color} className="loading-spinner-center" />
    );

    if(this.props.selectedIncident.incident)
    {
      content = (
        <IncidentDetailsContainer
          onCloseDetailsClicked={this.closeDetails}
          incident={this.props.selectedIncident.incident}
          relationships={this.props.selectedIncident.incident.relationships}
          perimeter={this.props.selectedIncident.perimeter}
          perimeterFields={this.props.selectedIncident.perimeterFields}
          missingConflictRelationships={this.state.missingConflictRelationships}
          onOpenMergeDialog={this.openMergeDialog}
          refetchIncident={this.refetchIncident.bind(this)}
          refetchIncidentByForID={this.refetchIncidentByForID.bind(this)}
          />
      );
    }
    return (
      <div className="content-container content-container-details">
        {content}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  map: state.map,
  selectedIncident: state.incident,
  relationships: state.relationships,
  missingConflictRelationships: state.missingConflictRelationships
})

const mapDispatchToProps = function (dispatch) {
  return bindActionCreators({
    ...incidentOperations
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Main)
